import { ButtonType, ButtonWidget } from '@tableau/widgets';
import { Formik, FormikHelpers, FormikProps } from 'formik';
import React = require('react');
import { SignInLogo } from '~src/app/spaces/Login/SignInLogo';
import { Messages } from '~src/codegen/Localize';
import { CommonStyles } from '~src/common/react/CommonStyles';
import { FormikTextBox } from '~src/commonInfra/components/FormikField';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import WebHttpClient from '~src/httpClient/WebHttpClient';
import { GeneratePasswordResetTokenRequest, IGeneratePasswordResetTokenParams } from '~src/ts/ServerApi/requests/GeneratePasswordResetTokenRequest';

import { LoginPageStyles } from '../styles/LoginPageStyles';


export interface PasswordResetFormProps {
    onSubmit: () => void;
}

export interface PasswordResetFormFields {
    username: string;
}

const buttonStyle: React.CSSProperties = {
    marginTop: CommonStyles.Sizes.XLargeSpace - CommonStyles.Sizes.DefaultSpace,
};


export function PasswordResetForm(props: PasswordResetFormProps) {

    function validateUserName(value: string): string | undefined {
        if (value.trim() === '') {
            return Messages.enterYourUsername();
        }
    }

    function requestPasswordReset(userName: string, formik: FormikHelpers<any>) {

        const requestParams: IGeneratePasswordResetTokenParams = {
            username: userName,
        };
        const passwordResetRequest = new GeneratePasswordResetTokenRequest(requestParams);

        WebHttpClient.sendRequest(passwordResetRequest)
            .then((result: IResult) => {
                props.onSubmit();
            });
    }

    return (
        <Formik
            initialValues={{ username: '' }}
            onSubmit={(values: PasswordResetFormFields, formik: FormikHelpers<any>) => {
                requestPasswordReset(values.username, formik);
            }}
            enableReinitialize={true}
        >

            {(formik: FormikProps<PasswordResetFormFields>) => (
                <div className='tb-login'>
                    <span className='tb-login-form-container'>
                        <SignInLogo />
                        <form name='requestPasswordResetForm' autoComplete='off' noValidate onSubmit={formik.handleSubmit} data-tb-test-id='requestPasswordResetForm'>
                            <div className='tb-login-text-box tb-padded'>
                                <FormikTextBox testId='textbox-username'
                                    label={Messages.username()}
                                    required={true}
                                    className={LoginPageStyles.textboxStyle}
                                    validate={validateUserName}
                                    showValidationMessage={true}
                                    eagerValidation={true}
                                    name='username'
                                    tabIndex={0}
                                />
                                <ButtonWidget buttonType={ButtonType.Outline}
                                    type="submit"
                                    style={buttonStyle}
                                    testId='btn-reset-request'
                                    disabled={!formik.values.username || !formik.isValid}
                                    className={LoginPageStyles.submitButtonStyle}
                                    tabIndex={0}>
                                    {Messages.sendPasswordResetEmail()}
                                </ButtonWidget>
                            </div>
                        </form>
                    </span>
                </div>

            )}
        </Formik>
    );
}